import { useParams } from 'react-router-dom';
import StudentProfileEditor from 'components/student-profile/StudentProfileEditor';

// La asesora valida y corrige la ficha de matrícula: ve las mismas secciones que admin.
export default function ModifyStudentAdviser() {
  const { id } = useParams();
  return <StudentProfileEditor studentId={id} backTo={`/plataforma/asesoras/ver-estudiante/${id}`} />;
}
